import { render, staticRenderFns } from "./WellnessDrawer.vue?vue&type=template&id=ddbbaa8c"
import script from "./WellnessDrawer.vue?vue&type=script&lang=js"
export * from "./WellnessDrawer.vue?vue&type=script&lang=js"
import style0 from "./WellnessDrawer.vue?vue&type=style&index=0&id=ddbbaa8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports